module.exports = __webpack_public_path__ + "static/media/my needs icon.49db0548.svg";